import type { CityConfig } from "../city-template/types";

export const watertownSDConfig: CityConfig = {
  city: "Watertown",
  state: "South Dakota",
  stateAbbr: "SD",
  slug: "watertown-sd",
  route: "/watertown-sd",
  title: "Emergency Passport Watertown, SD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Watertown, SD — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Codington County, Redlin Art Center visitors, Lake Kampeska families, and I-29 corridor travelers. No Minneapolis trip needed.",
  h1: "Emergency & Expedited Passport Services in Watertown, South Dakota",
  heroSubtitle: "Codington County manufacturing professional heading to an international trade show? Lake Area Technical College student preparing for a study abroad program? Watertown family with a bucket-list trip to Europe planned? We help Watertown residents — from Redlin Art Center staff to Lake Kampeska families to I-29 corridor travelers — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30-100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20view%20of%20Watertown%20South%20Dakota%20with%20the%20Redlin%20Art%20Center%20and%20its%20iconic%20brick%20campus%20reflected%20in%20the%20serene%20pond%2C%20the%20Big%20Sioux%20River%20winding%20through%20the%20city%2C%20downtown%20Watertown%20along%20Kemp%20Avenue%20with%20historic%20storefronts%2C%20Lake%20Kampeska%20shimmering%20in%20the%20distance%20at%20golden%20hour%2C%20the%20Glacial%20Lakes%20region%20landscape%20with%20wide%20prairie%20skies%2C%20professional%20travel%20photography%20with%20warm%20tones&width=1800&height=700&seq=watertown-sd-hero-2026&orientation=landscape",
  heroImageAlt: "Watertown South Dakota Redlin Art Center and downtown Kemp Avenue",
  geoPosition: "44.8994;-97.1151",
  geoPlacename: "Watertown, South Dakota",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Nearest regional passport agency — located approximately 220 miles from Watertown; about a 3.5-hour drive via US-212/MN-7",
  },
  nearbyCitiesZips: [
    { name: "Watertown", zips: "57201" },
    { name: "Florence", zips: "57235" },
    { name: "Henry", zips: "57243" },
    { name: "Castlewood", zips: "57223" },
    { name: "Clark", zips: "57225" },
    { name: "Milbank", zips: "57252" },
    { name: "Webster", zips: "57274" },
    { name: "Sisseton", zips: "57262" },
  ],
  benefits: [
    { icon: "ri-building-2-line", title: "Redlin Art Center & Tourism Economy", desc: "The Terry Redlin Art Center draws visitors from across the country and around the world — making Watertown an unexpected international tourism destination. Art center staff, tourism professionals, and visiting artists travel internationally for exhibitions and cultural exchanges." },
    { icon: "ri-graduation-cap-line", title: "Lake Area Technical College", desc: "Lake Area Tech is one of the nation's top community colleges, with students and faculty participating in international training programs, skills competitions, and study abroad. Students often need first-time passports on tight academic timelines." },
    { icon: "ri-road-map-line", title: "I-29 Corridor Hub", desc: "Watertown anchors the northeastern South Dakota I-29 corridor — serving travelers from Clark, Milbank, Webster, and Sisseton who need passport services without driving to Sioux Falls or Minneapolis." },
    { icon: "ri-landscape-line", title: "Glacial Lakes & Outdoor Recreation", desc: "Watertown is the gateway to the Glacial Lakes region — with Lake Kampeska, Pelican Lake, and the Big Sioux River attracting outdoor enthusiasts. Canadian fishing and camping trips are popular, requiring reliable passport processing for frequent border crossings." },
  ],
  internalLinks: [
    { name: "Expedited passport in Sioux Falls, SD", route: "/sioux-falls" },
    { name: "Fast passport services in Aberdeen, SD", route: "/aberdeen-sd" },
    { name: "Quick passport services in Brookings, SD", route: "/brookings" },
    { name: "South Dakota passport services overview", route: "/south-dakota" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Watertown via secure registered courier with direct access to the Minneapolis Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 3.5+ hours to Minneapolis. Watertown residents can ship from any UPS Store, FedEx Office, or post office location across Codington County.",
  fpcOfficeDistance: "Serving Watertown, Milbank, Webster, Clark, Sisseton, and all Glacial Lakes region communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Watertown and the Glacial Lakes region. From the Redlin Art Center to Lake Kampeska, from downtown Kemp Avenue to the Lake Area Tech campus — we serve all of Codington County. Our courier service eliminates the need to drive 220 miles to Minneapolis.",
  nearbyCitiesIntro: "We serve Watertown and surrounding communities including Milbank, Webster, Clark, Sisseton, and Castlewood. Our service covers Codington County and the northeastern South Dakota region.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Watertown as simple as possible — with the reliability Lake Area Tech students, Glacial Lakes families, and Codington County professionals need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee.",
  mistakesIntro: "Watertown's mix of Lake Area Tech student needs, manufacturing industry travel, and Canadian border proximity creates unique passport situations. Here are the most common mistakes we see.",
  testimonialsIntro: "Watertown travelers — from Lake Area Tech students to Codington County manufacturers to Glacial Lakes families — trust us when international travel deadlines arrive and Minneapolis is simply too far.",
  faqIntro: "Have questions about expedited passports in Watertown, SD? Here are the most common ones we hear from Codington County and the Glacial Lakes region.",
  statePageRoute: "/states/south-dakota",
  statePageName: "South Dakota",
  servicesIntro: "Whether you need a renewal before a Lake Area Tech international program, an emergency passport for a manufacturing trade show, or a first-time passport for a Codington County family vacation — Fast Passport Center handles it with reserved courier submission availability.",
  dmvWebsite: "https://dps.sd.gov/driver-licensing",
  dmvLabel: "South Dakota DPS Driver Licensing — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Minneapolis agency is 220 miles from Watertown", "3.5+ hour drive — takes most of a day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2-9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Minneapolis trip needed", "Ideal for Lake Area Tech students and manufacturers", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3-5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service through post office", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1-2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Lake Area Tech competition team traveling internationally next week? Manufacturing trade show in Germany with 5 days' notice? Our emergency courier service submits directly via reserved slots — as fast as 24 hours for Watertown travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Watertown residents renew fast — no agency visit required for most renewals. Perfect for Codington County professionals and Glacial Lakes frequent travelers.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Codington County residents through every step with clear instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms like DS-64. We guide you through everything needed so your study abroad or trade show trip isn't derailed.",
      bullets: ["DS-64 form guidance", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Codington County family trip stays on track.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations and IDs.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Watertown SD", description: "Urgent passport processing for Watertown South Dakota travelers." },
    { name: "Expedited Passport Renewal Watertown SD", description: "Fast passport renewal for Watertown residents." },
    { name: "First-Time Passport Watertown SD", description: "New passport application services for Watertown residents." },
    { name: "Child Passport Watertown SD", description: "Minor passport services for Watertown families." },
    { name: "Name Change Passport Watertown SD", description: "Name correction for Watertown residents." },
  ],
  testimonials: [
    {
      name: "Tyler H.",
      location: "Watertown — LATI Student",
      rating: 5,
      text: "Lake Area Tech welding student — I qualified for the SkillsUSA national competition and the international round was in Germany. I had 3 weeks to get my first passport. Fast Passport Center walked me through the whole process and it arrived in 6 days. Competed in Stuttgart and placed top 10.",
      service: "First-Time Passport — Skills Competition",
    },
    {
      name: "Diane M.",
      location: "Watertown",
      rating: 5,
      text: "I work at Terex and got tapped for a supplier visit to our facility in Italy with 10 days' notice. My passport was expired. Fast Passport Center renewed it in 4 days. I was on the plane to Milan and the trip was a huge success for our plant.",
      service: "Expedited Passport — Manufacturing Travel",
    },
    {
      name: "The Olson Family",
      location: "Watertown",
      rating: 5,
      text: "We booked a family cruise to Alaska that departs from Vancouver. Three of us needed renewals and our daughter needed her first passport. Fast Passport Center handled all four. We spent a week exploring glaciers and the Inside Passage together.",
      service: "Family Passports — Cruise",
    },
    {
      name: "Linda R.",
      location: "Watertown",
      rating: 5,
      text: "Retired teacher who finally booked a dream trip to Ireland. I realized my passport expired 3 months ago — just 2 weeks before departure. I thought I'd have to cancel. Fast Passport Center renewed it in 4 days. The Cliffs of Moher were every bit as beautiful as I imagined.",
      service: "Expedited Renewal — Bucket List Trip",
    },
  ],
  facilities: [
    {
      id: "watertown-1",
      name: "Watertown Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "405 E Kemp Ave",
      city: "Watertown",
      state: "SD",
      zip: "57201",
      phone: "(605) 886-8363",
      hours: "Mon-Fri 9:00 AM - 4:00 PM (appointment required)",
      distance: "Downtown Watertown on Kemp Avenue",
      website: "https://tools.usps.com/find-location.htm?location=1368594",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility for Watertown and Codington County. Passport photos available on-site. Appointment recommended — limited walk-in availability.",
      icon: "ri-mail-line",
    },
    {
      id: "watertown-2",
      name: "Codington County Clerk of Courts",
      type: "County Clerk Passport Acceptance",
      address: "14 1st Ave SE",
      city: "Watertown",
      state: "SD",
      zip: "57201",
      phone: "(605) 882-5095",
      hours: "Mon-Fri 8:00 AM - 5:00 PM",
      distance: "Downtown Watertown — Codington County Courthouse",
      website: "https://www.codington.org/",
      websiteLabel: "Codington County Website",
      notes: "Alternative to post office acceptance. Does not offer photo services — bring your own passport photo. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "watertown-3",
      name: "Milbank Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "111 S Main St",
      city: "Milbank",
      state: "SD",
      zip: "57252",
      phone: "(605) 432-4511",
      hours: "Mon-Fri 9:00 AM - 4:00 PM (appointment required)",
      distance: "Milbank — about 30 miles east on US-212",
      website: "https://tools.usps.com/find-location.htm?location=1368587",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility for Grant County residents. About 30-minute drive from Watertown. Passport photos available.",
      icon: "ri-mail-line",
    },
    {
      id: "watertown-4",
      name: "Brookings Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3045 Lefevre Dr",
      city: "Brookings",
      state: "SD",
      zip: "57006",
      phone: "(605) 692-4243",
      hours: "Mon-Fri 9:00 AM - 4:00 PM (appointment required)",
      distance: "Brookings — about 50 miles south on I-29",
      website: "https://tools.usps.com/find-location.htm?location=1368576",
      websiteLabel: "USPS Location",
      notes: "Larger university-town acceptance facility with SDSU-area services. Full passport photo service. About 45-minute drive from Watertown.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Minneapolis Passport Agency, 220 miles from Watertown", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 3.5+ hours to Minneapolis", fpc: "Most Watertown travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission as registered courier" },
    { feature: "Practicality for Watertown", agency: "220-mile drive — impractical for Codington County", fpc: "Entirely remote — ship from Watertown, receive at your door" },
    { feature: "Cost vs Resellers", agency: "Government fees — plus travel costs and days off work", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Who Can Use It", agency: "Strict eligibility — life-or-death emergency only", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Watertown Context", agency: "No LATI, Redlin Art Center, or Codington County expertise", fpc: "Full Watertown knowledge — Lake Area Tech, Redlin Center, Glacial Lakes" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Lake Area Tech Timeline Compression",
      description: "Lake Area Tech students selected for international competitions or training programs often have just 3-6 weeks between selection and departure. First-time applicants need both an acceptance facility visit and processing time — starting the process after selection notification creates unnecessary stress.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Canadian Border Proximity Assumptions",
      description: "Watertown is close to the Canadian border — about 3 hours to the Manitoba crossing. Residents heading to Canada for fishing trips sometimes assume passport rules are relaxed. Land border crossings still require valid passports or passport cards — and expired documents mean being turned away at the border.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Manufacturing Travel Scheduling Conflicts",
      description: "Watertown's manufacturing sector — Terex, Angus-Palm, and others — sends employees internationally on short notice for supplier visits, equipment installations, and trade shows. Expired passports discovered the week before departure are common. Start passport renewal immediately when international travel is even a possibility.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date — whether a Lake Area Tech competition, manufacturing trade show, or family international trip." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist tailored to your situation — LATI student, Codington County professional, or Glacial Lakes family." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send documents using overnight shipping. Most Watertown clients ship from the Watertown Post Office on Kemp Avenue. No Minneapolis trip needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our center. We submit through reserved agency slots — so Watertown travelers never need to drive 220 miles to Minneapolis." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is shipped directly to your Watertown address. No agency visit. No Minneapolis. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Watertown, South Dakota?", a: "We offer Watertown-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5-10 business days. Because the nearest regional passport agency is Minneapolis (220 miles away), our remote courier service is the most practical fast option for Codington County." },
    { q: "Do I need to visit a Watertown office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Watertown Post Office or Codington County Clerk), then ship documents overnight. We handle State Department submission and return your passport to your Watertown address." },
    { q: "Where can I get passport acceptance in Watertown?", a: "Watertown has acceptance at the Main Post Office (405 E Kemp Ave) and the Codington County Clerk (14 1st Ave SE). Nearby alternatives include post offices in Milbank (30 miles east) and Brookings (50 miles south on I-29)." },
    { q: "Can Lake Area Tech students get expedited passports?", a: "Yes. Lake Area Technical College students participating in international competitions, training programs, or study abroad can use our expedited courier service. We understand Lake Area Tech's academic calendar and can process first-time and renewal passports before program departure dates." },
    { q: "How does the Redlin Art Center affect Watertown passport needs?", a: "The Terry Redlin Art Center draws visitors from across the world, and its staff participates in international art exhibitions and cultural exchanges. We've helped art center professionals get fast passports for international museum conferences and traveling exhibitions." },
    { q: "Can I get a passport photo in Watertown?", a: "Yes. The Watertown Main Post Office offers on-site passport photos. Walgreens and Walmart in Watertown also provide passport photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "What documents do Watertown applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent." },
  ],
  photoLocations: [
    { name: "Watertown Main Post Office", address: "405 E Kemp Ave, Watertown, SD 57201", hours: "Mon-Fri 9 AM - 4 PM (photo service available)" },
    { name: "Walmart Supercenter — Watertown", address: "1200 29th St SE, Watertown, SD 57201", hours: "Daily 6 AM - 11 PM" },
    { name: "Walgreens — Watertown", address: "121 9th Ave SE, Watertown, SD 57201", hours: "Daily 8 AM - 10 PM" },
  ],
  dmvLocations: [
    {
      name: "Watertown DPS Driver License Exam Station",
      address: "2001 9th Ave SW, Watertown, SD 57201",
      hours: "Mon-Fri, 7:00 AM - 5:30 PM (appointment recommended)",
      note: "Driver licenses, REAL ID, written and road tests. Main DPS office serving Codington County.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "ATY",
      name: "Watertown Regional Airport",
      distance: "About 3 miles northwest of downtown Watertown",
      address: "4500 Airport Rd, Watertown, SD 57201",
      note: "Regional airport with daily flights to Denver International Airport (DEN) via United Express. Direct international gateway connection from Watertown. About 5 minutes from downtown.",
      flightUrl: "https://www.watertownsd.us/211/Airport",
      flightLabel: "Watertown Airport Website",
      featured: true,
    },
    {
      code: "FSD",
      name: "Sioux Falls Regional Airport",
      distance: "About 100 miles south of Watertown via I-29",
      address: "2801 N Jaycee Ln, Sioux Falls, SD 57104",
      note: "Largest airport in South Dakota with flights to MSP, DEN, ORD, DFW, and more. More international connection options. About 1.5 hours from Watertown.",
      flightUrl: "https://www.sfairport.com/",
      flightLabel: "Sioux Falls Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified South Dakota birth certificates from the SD Department of Health Vital Records. Online, mail, or in-person options available.",
      url: "https://doh.sd.gov/records/stillbirth.aspx",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Codington County Register of Deeds. Certified copies for name changes and passport applications.",
      url: "https://www.codington.org/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Codington County Clerk of Courts. Required for name change passport corrections.",
      url: "https://www.codington.org/",
    },
    {
      icon: "ri-user-smile-line",
      label: "Death Certificate",
      desc: "Request certified South Dakota death certificates from the SD Department of Health Vital Records. Online, mail, or in-person options available.",
      url: "https://doh.sd.gov/records/stillbirth.aspx",
    },
  ],
};